import { jsx, jsxs } from 'react/jsx-runtime';
import { useContext, useState, useRef, useEffect } from 'react';
import { ThemeContext } from 'styled-components';
import Measure from 'react-measure';
import { useLocation } from 'react-router-dom';
import '../Header/index.js';
import { FullPageLayout, Wrapper, Sidebar, Content, ContentContainer } from './SplitLayout.styles.js';
import { useOnClickOutside, MODAL_SELECTOR, DROPDOWN_SELECTOR } from '@sketch/utils';
import { callIfFunction } from '../SidebarLayout/callIfFunction.js';
import { Header } from '../Header/Header.js';

/**
 * COMPONENT
 * Used for documents view (homepage), it provides a left sidebar to show the
 * main navigation
 */
const SplitLayout = ({ title, sidebar, header, footer, children, }) => {
    const theme = useContext(ThemeContext);
    const [headerHeight, setHeaderHeight] = useState(theme.header.height);
    // Only used for mobile
    const [isSidebarLeftOpen, setSidebarLeftOpen] = useState(false);
    const closeSidebar = () => {
        if (isSidebarLeftOpen) {
            // setTimeout is needed to make sure `setSidebarLeftOpen` is called after
            // any other click event listener, for example the hamburger icon click
            setTimeout(() => setSidebarLeftOpen(false), 0);
        }
    };
    // Close the left sidebar when the user clicks outside of it
    const sidebarRef = useRef(null);
    useOnClickOutside(sidebarRef, closeSidebar, {
        includeSelectors: [MODAL_SELECTOR, DROPDOWN_SELECTOR],
    });
    // Make sure the sidebar is closed every time the route changes
    const location = useLocation();
    useEffect(() => {
        closeSidebar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);
    /*
     * Watching header height changes to reposition <Sidebar/>
     * and <PageContent /> when banners are displayed.
     */
    const handleResize = ({ entry }) => {
        if (!entry) {
            return;
        }
        // Prevent setting a new state when the value is the same
        if (headerHeight === entry.height) {
            return;
        }
        setHeaderHeight(entry.height);
    };
    return (jsx(FullPageLayout, Object.assign({ title: title, showHeader: false }, { children: jsxs(Wrapper, { children: [sidebar && (jsx(Sidebar, Object.assign({ ref: sidebarRef, isSidebarOpen: isSidebarLeftOpen }, { children: callIfFunction(sidebar) }))), jsxs(Content, Object.assign({ "data-testid": "page-content" }, { children: [jsx(Measure, Object.assign({ onResize: handleResize }, { children: ({ measureRef }) => (jsx(Header, Object.assign({ ref: measureRef }, { children: callIfFunction(header, {
                                    isSidebarLeftOpen,
                                    setSidebarLeftOpen,
                                }) }))) })), jsx(ContentContainer, Object.assign({ isSidebarOpen: isSidebarLeftOpen }, { children: callIfFunction(children) })), callIfFunction(footer)] }))] }) })));
};

export { SplitLayout };
